import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { css } from '@compiled/react';

import { Flex, Box, Text, xcss } from '@atlaskit/primitives';
import Image from '@atlaskit/image';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';

import { HTV2DismissIcon } from './HTV2DismissIcon';
import { type OnboardingAction } from './useOnboardingActions';

const contentContainerStyles = xcss({
	paddingTop: 'space.250',
	paddingBottom: 'space.200',
	paddingLeft: 'space.200',
	paddingRight: 'space.200',
});

const cardStyles = xcss({
	border: `1px solid ${token('color.border')}`,
	borderRadius: '8px',
	background: token('elevation.surface.overlay'),
});

const imageContainerStyles = xcss({
	position: 'relative',
});

const imageStyles = css({ width: '100%' });

const descriptionContainerStyles = xcss({
	// Ensure the description text is always 3 lines tall
	height: '4.28em', // (20px line height * 3 lines) / 14px font size
});

export const HTV2ActionCard = ({ action }: { action: OnboardingAction }) => {
	return (
		<Flex direction="column" xcss={cardStyles}>
			<Box xcss={imageContainerStyles}>
				<Image css={imageStyles} src={action.image.light} srcDark={action.image.dark} alt="" />
				<HTV2DismissIcon />
			</Box>
			<Flex xcss={contentContainerStyles} direction="column" gap="space.100">
				<Heading size="xsmall">
					<FormattedMessage {...action.title} />
				</Heading>
				<Box xcss={descriptionContainerStyles}>
					<Text maxLines={3}>
						<FormattedMessage {...action.description} />
					</Text>
				</Box>
				<Flex justifyContent="end">{action.cta}</Flex>
			</Flex>
		</Flex>
	);
};
